<template>
  <div class="video-player-modal" v-show="modalOpen">
    <div class="modal-title">
      <img src="~@/assets/img/icon-close2.png" class="title-close-btn" @click="handleModalCancel"/>
    </div>
    <div class="video-list">
      <div class="video-item"
           v-for="(item, index) in players"
           :class="[isSingle ? 'single-video-item' : '', item.id === currentVideoPlayerId ? 'video-item-active' : '']"
           v-show="!isSingle || (isSingle && (currentVideoPlayerId !== 0 && item.id === currentVideoPlayerId) || (currentVideoPlayerId === 0 && index === 0)) "
           :key="'videoItem' + index"
           ref="videoItem"
           @click="item.active ? selectVideoPlayer(item) : ''"
      >
        <div class="video-item-title" v-show="tileVisible">
          <div class="video-item-title-left">{{ item.active ? item.streamNodeName : item.title }}</div>
          <!--            <div class="video-item-title-right" v-if="item.active">-->
          <div class="video-item-title-right">
            <a @click="capturePictureJpeg()" href="javascript:;" class="video-item-btn camera-btn"></a>
            <!--<a href="javascript:;" class="video-item-btn save-btn"></a>-->
            <a @click="stopVideo(item.streamNodeId)" href="javascript:;" class="video-item-btn close-btn"></a>
          </div>
        </div>
        <div class="video-item-content" ref="videoPlayerContainer">
          <!--视频控件-->
          <video :id="'video-player' + String(index + 1)" ref="videoPlayer" class="video-player" v-show="item.active"
                 controls autplayerParamslay></video>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeTabName" v-show="controlTabsOpen" @tab-click="handleTabClick">
      <el-tab-pane label="云台控制" name="0">
        <div class="ptz-control">
          <div class="ptz-control-left">
            <ul class="direction-list">
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_UP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_UP)"><i
                class="iconfont icon-top"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHTUP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHTUP)">
                <i class="iconfont icon-right-top"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHT)"><i
                class="iconfont icon-right-arrow"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHTDOWN)"
                  @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHTDOWN)"><i class="iconfont icon-right-bottom"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_DOWN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_DOWN)"><i
                class="iconfont icon-bottom"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFTDOWN)"
                  @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFTDOWN)"><i class="iconfont icon-left-bottom"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFT)"><i
                class="iconfont icon-left-arrow"></i></li>
              <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFTUP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFTUP)"><i
                class="iconfont icon-left-top"></i></li>
            </ul>
            <div class="ptz-control-speed">
              <el-slider v-model="hSpeed" :min="1" :max="10"></el-slider>
            </div>
          </div>
          <div class="ptz-control-right">
            <ul class="control-btn-list">
              <li class="control-btn-list-item">
                <div class="control-btn-title">变  倍</div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_ZOOM_IN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_ZOOM_IN)"
                     class="control-btn danbei-btn"></div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_ZOOM_OUT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_ZOOM_OUT)"
                     class="control-btn duobei-btn"></div>
              </li>
              <li class="control-btn-list-item">
                <div class="control-btn-title">光  圈</div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_INCREASE)"
                     @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_STOP_INCREASE)" class="control-btn dagq-btn"></div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_DECREASE)"
                     @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_STOP_DECREASE)" class="control-btn xiaogq-btn"></div>
              </li>
              <li class="control-btn-list-item">
                <div class="control-btn-title">聚  焦</div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_FOCUS_OUT)"
                     @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_FOCUS_OUT)" class="control-btn jujiao1-btn"></div>
                <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_FOCUS_IN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_FOCUS_IN)"
                     class="control-btn jujiao2-btn"></div>
              </li>
            </ul>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="预置点控制" name="1">
        <div class="preset-control">
          <el-table ref="presetInfoTable"
                    :data="presetInfoTableData"
                    border highlight-current-row
                    style="width: 100%"
                    v-loading="loading"
                    element-loading-text="努力加载中..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    @current-change="handlePresetInfoTableCurrentChange">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="点号" prop="presetNum" width="80"></el-table-column>
            <el-table-column label="操作">
              <el-button type="primary" round @click="presetControl($type.ptzCommands.DVR_PTZ_MOVE_PRESET)">调用</el-button>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            @current-change="handlePresetInfoCurrentPageChange"
            :current-page.sync="presetInfoTableQueryParams.pageNum"
            :page-size.sync="presetInfoTableQueryParams.pageSize"
            layout="total, prev, pager, next"
            :total="presetInfoTableTotalRow">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="辅助控制" name="2">
        <div class="do-control">
          <el-table ref="controlNodeTable"
                    :data="controlNodeTableData"
                    border highlight-current-row
                    style="width: 100%"
                    v-loading="loading"
                    element-loading-text="努力加载中..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    @current-change="handleControlNodeTableCurrentChange">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="状态" prop="controlValue" width="80">
              <template slot-scope="scope">{{$type.getResourceControlStateText(scope.row.resourceKind, scope.row.controlledObjectKind,
                scope.row.controlValue, scope.row.valueType, 0, '')}}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
              <el-switch v-model="scope.row.inputControlState" :active-value="1" :inactive-value="0" @change="switchChange(scope.row)"></el-switch>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            @current-change="handleControlNodeCurrentPageChange"
            :current-page.sync="controlNodeTableQueryParams.pageNum"
            :page-size.sync="controlNodeTableQueryParams.pageSize"
            layout="total, prev, pager, next"
            :total="controlNodeTableTotalRow">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import VideoPlayerModal from './VideoPlayerModal.js'
export default VideoPlayerModal
</script>

<style lang="scss">
@import "VideoPlayerModal";
</style>



// WEBPACK FOOTER //
// src/views/common/VideoPlayerModal/VideoPlayerModal.vue